const Linkedin = (props: INavIcon) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
            <path d="M20.75 0H4.25C2.17893 0 0.5 1.67893 0.5 3.75V20.25C0.5 22.3211 2.17893 24 4.25 24H20.75C22.8211 24 24.5 22.3211 24.5 20.25V3.75C24.5 1.67893 22.8211 0 20.75 0Z" fill="#2867B2" />
            <path d="M9.2 18H6.65V9.975H9.2V18ZM7.925 8.85C7.1 8.85 6.5 8.25 6.5 7.425C6.5 6.6 7.175 6 7.925 6C8.75 6 9.35 6.6 9.35 7.425C9.35 8.25 8.75 8.85 7.925 8.85ZM18.5 18H15.95V13.65C15.95 12.375 15.425 12 14.675 12C13.925 12 13.175 12.6 13.175 13.725V18H10.625V9.975H13.025V11.1C13.25 10.575 14.15 9.75 15.425 9.75C16.85 9.75 18.35 10.575 18.35 13.05V18H18.5Z" fill="white" />
        </svg>
    );
}

export default Linkedin;